export enum WarScreenBettingTypes {
    TABLE,
    GUI,
    SIDE,
}
